<template>
  <div id="bortBar" class="bortBar-cla">
    sss
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { getOption } from './getOption'
export default {
  data() {
    return {
      myChart: null,
      option: null
    }
  },
  mounted() {
    var dom = document.getElementById('bortBar')
    this.myChart = echarts.init(dom)
    this.option = getOption()
    setTimeout(() => {
      this.renderChar()
    }, 0)
    setInterval(() => {
      this.renderChar()
    }, 5000)
  },
  methods: {
    randomString(len) {
      let $chars =
        'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678' /** **默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      return $chars.charAt(len)
    },

    renderChar() {
      let data = []
      for (let i = 0; i < 10; ++i) {
        let str = this.randomString(i)
        data[i] = [Math.round(Math.random() * 2000), str]
      }
      this.option.series[0].data = data
      this.myChart.setOption(this.option)
    }
  }
}
</script>

<style>
.bortBar-cla {
  height: 280px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/sortBar/sortBar.vue